import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern metal fence panel: like a wall it runs along the X axis through
// the tile centre, exactly one tile (1 m) long, ~1.1 m high, matte black.
const METAL = "#2e2e30";

const BAR_X = [-0.36, -0.24, -0.12, 0, 0.12, 0.24, 0.36];

export const fenceMetal = defineModel({
  id: "fence-metal",
  batchId: "modern",
  name: "Metal fence",
  tags: ["modern", "outdoor", "garden", "fence", "metal"],
  summary: "A matte-black metal bar fence panel, one tile long.",
  description:
    "A contemporary metal fence of the Modern Living kit: 1 m long along X, " +
    "1.1 m high — two square posts, top and bottom rails and seven thin " +
    "vertical bars, all matte black. Chain tiles for longer runs; rotate " +
    "90 degrees to orient.",
  tiles: { w: 1, h: 1 },
  footprint: 0.7,
  parts(): Part[] {
    const parts: Part[] = [
      // Square posts at the tile edges.
      { geometry: new THREE.BoxGeometry(0.07, 1.1, 0.07), color: METAL, position: [-0.47, 0.55, 0] },
      { geometry: new THREE.BoxGeometry(0.07, 1.1, 0.07), color: METAL, position: [0.47, 0.55, 0] },
      // Top and bottom rails.
      { geometry: new THREE.BoxGeometry(1.0, 0.05, 0.05), color: METAL, position: [0, 1.05, 0] },
      { geometry: new THREE.BoxGeometry(1.0, 0.05, 0.05), color: METAL, position: [0, 0.14, 0] },
    ];
    for (const x of BAR_X) {
      parts.push({
        geometry: new THREE.BoxGeometry(0.025, 0.91, 0.025),
        color: METAL,
        position: [x, 0.585, 0],
      });
    }
    return parts;
  },
  animations: [],
});
